import { find, get } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { OPERATOR_NAMES } from './constants';

export const isDateRangeOperator = (operator) => operator === OPERATOR_NAMES.between || operator === OPERATOR_NAMES.notBetween;
export const isMultipleOperator = (operator) => operator === OPERATOR_NAMES.anyOf || operator === OPERATOR_NAMES.noneOf;
export const isEmptyOperator = (operator) => operator === OPERATOR_NAMES.empty || operator === OPERATOR_NAMES.notEmpty;

const transformDateRuleOut = ({ field, operator, value }) => {
  const rule = {
    field,
    operator,
  };

  if (operator === OPERATOR_NAMES.dateBefore) {
    rule.operator = OPERATOR_NAMES.between;
    rule.to = value;
  } else if (operator === OPERATOR_NAMES.dateAfter) {
    rule.operator = OPERATOR_NAMES.between;
    rule.from = value;
  } else if (isDateRangeOperator(operator)) {
    rule.from = value.from;
    rule.to = value.to;
  } else {
    rule.value = value;
  }

  return rule;
};

const transformDateRuleIn = ({ field, operator, value, from, to }) => {
  const rule = {
    id: `r-${uuidv4()}`,
    field,
    operator,
    value,
  };

  if (from && !to) {
    rule.operator = OPERATOR_NAMES.dateAfter;
    rule.value = { from };
  } else if (!from && to) {
    rule.operator = OPERATOR_NAMES.dateBefore;
    rule.value = { to };
  } else if (from && to) {
    rule.value = { from, to };
  }

  return rule;
};

const transformChargerComponentRuleOut = (rule) => {
  const operator = JSON.parse(rule.operator);

  return {
    operator: 'NESTED',
    path: 'components',
    searchCondition: {
      operator: 'AND',
      conditions: [
        {
          field: 'comp_name',
          operator: operator.name,
          value: rule.value?.name || '',
        },
        {
          field: 'comp_ver',
          operator: operator.version,
          value: rule.value?.version || '',
        },
      ],
    },
  };
};

export const transformQueryOut = (query, fields) =>
  query
    .filter((item) => item)
    .map((item) => {
      if (item.combinator && item.rules) {
        return {
          operator: item.combinator,
          conditions: transformQueryOut(item.rules, fields),
        };
      }

      const fieldType = get(find(fields, { name: item.field }), 'valueEditorType');

      if (fieldType === 'date') {
        return transformDateRuleOut(item);
      }

      if (fieldType === 'chargerPackage') {
        return transformChargerComponentRuleOut(item);
      }

      if (item.field === 'f_status' && item.value === 'IN_PROGRESS') {
        return {
          field: item.field,
          operator: OPERATOR_NAMES.anyOf,
          value: ['IN_PROGRESS', 'SENT'],
        };
      }

      if (item.field === 'f_status' && item.value === 'ERROR') {
        return {
          field: item.field,
          operator: OPERATOR_NAMES.anyOf,
          value: ['ERROR', 'FAILED'],
        };
      }

      return {
        field: item.field,
        operator: item.operator,
        value: item.value,
      };
    });

export const transformQueryIn = (query, fields) =>
  query.map((item) => {
    if (item.operator && item.conditions) {
      return {
        id: `g-${uuidv4()}`,
        combinator: item.operator,
        rules: transformQueryIn(item.conditions, fields),
      };
    }

    const fieldType = find(fields, { name: item.field }).type;

    if (fieldType === 'date') {
      return transformDateRuleIn(item);
    }

    return {
      ...item,
      id: `r-${uuidv4()}`,
    };
  });

export const clearRulesIds = (rules) => {
  rules.forEach((item) => {
    delete item.id;

    if (item.rules) {
      clearRulesIds(item.rules);
    }
  });
};

export const fillRulesWithIds = (rules) => {
  rules.forEach((item) => {
    if (item.rules) {
      item.id = `g-${uuidv4()}`;
      fillRulesWithIds(item.rules);
    } else {
      item.id = `r-${uuidv4()}`;
    }
  });
};
